import { render } from "./transferPositionProducts.vue?vue&type=template&id=63857dfb&scoped=true"
import script from "./transferPositionProducts.vue?vue&type=script&lang=js"
export * from "./transferPositionProducts.vue?vue&type=script&lang=js"

import "./transferPositionProducts.vue?vue&type=style&index=0&id=63857dfb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63857dfb"]])

export default __exports__